import { useMemo } from 'react';

import { type EntityLookupOptions } from '@air/api';

import { useFiltersContext } from '~/providers/FiltersProvider';
import { isDateCustomFieldUrlParam } from '~/utils/filters/dateCustomFieldFilter';
import { customFieldIdFromUrlParam, isPlainTextCustomFieldUrlParam } from '~/utils/filters/plainTextCustomFieldFilter';

export const useAppliedCustomFieldsFilters = () => {
  const {
    filters: { customFields },
  } = useFiltersContext();

  const appliedCustomFieldsFilters = useMemo(() => {
    if (!customFields) {
      return [];
    }

    return Object.keys(customFields).reduce<NonNullable<EntityLookupOptions['customFields']>>(
      (collected, paramName) => {
        const cfId = customFieldIdFromUrlParam(paramName);

        if (!cfId || isPlainTextCustomFieldUrlParam(paramName) || isDateCustomFieldUrlParam(paramName)) {
          return collected;
        }

        collected.push({
          id: cfId,
          customFieldValueIds: customFields[paramName] ?? [],
        });
        return collected;
      },
      [],
    );
  }, [customFields]);

  return {
    appliedCustomFieldsFilters,
  };
};
